import { render } from "./FAQPage.vue?vue&type=template&id=5482a536&scoped=true"
import script from "./FAQPage.vue?vue&type=script&lang=js"
export * from "./FAQPage.vue?vue&type=script&lang=js"

import "./FAQPage.vue?vue&type=style&index=0&id=5482a536&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5482a536"]])

export default __exports__